import React, {useEffect, useState} from 'react';
import {useTranslation, withTranslation} from "react-i18next";
import {connect, DispatchProp} from "react-redux";
import {RootState} from "../../../../reducers";
import ItemHelper from "../../../services/Menu/services/Item/ItemHelper";
import Utils from "../../../utils/Utils";
import Money from "../../Common/Money";
import {getCategories, getItems} from "../../../services/Menu/reducer";
import {api} from "../../../services/Api/api";
import {ReactComponent as GiftIco} from "../../../../images/icons/gift.svg";
import PopupModal from "../../Modal/PopupModal";

interface OwnProps {
    name: any,
    promotionId: any,
    onHide: () => void,
    onShow?: () => void
}

type Props = ReturnType<typeof mapStateToProps> & OwnProps & DispatchProp;

function PromotionInfoModalComponent(props: Props) {
    const [promotion, setPromotion] = useState<any | undefined>(undefined);
    const [error, setError] = useState<string | undefined>(undefined);
    const {t} = useTranslation();

    useEffect(() => {
        showPromotionInfo(props.promotionId)
    }, [])

    const fetchPromotion = async (promotionId: any) => {
        return api.getPromotion(promotionId);
    }

    const showPromotionInfo = async (promotionId: any) => {
        try {
            const promotionConfig = await fetchPromotion(promotionId)
            setPromotion(promotionConfig);
        } catch (err) {
            setError(t('modules.promotion.field.problem_with_promotion_fetching.title'));
        }
    }

    const renderTypes = () => {
        const types = [];

        if (promotion.dine_in) {
            types.push("DINE_IN");
        }
        if (promotion.delivery) {
            types.push("DELIVERY");
        }
        if (promotion.takeaway) {
            types.push("PICK_UP");
        }
        if (promotion.room_service) {
            types.push("ROOM_SERVICE");
        }
        if (types.length <= 0) {
            return undefined;
        }

        return types.map(type => t("enums.order.type." + type));
    }

    const types = promotion ? renderTypes() : undefined;

    const getConditions = (conditions: any) => {
        return conditions.map((condition: any) => {
            if (condition.type == "ITEM") {
                let item = ItemHelper.getItem(props.items, condition.entity_id);
                if (!item) return undefined;
                return item.translation.name;
            }
            if (condition.type == "CATEGORY") {
                let category = props.categories.filter((categoryItem: any) => categoryItem.id === condition.entity_id)[0];
                if (!category) return undefined;
                return category.translation.name;
            }
            return undefined;
        }).filter((x: any) => x !== undefined);
    }

    return <PopupModal
        title={props.name}
        description={promotion?.description ? Utils.nl2brString(promotion.description) : undefined}
        show
        onHide={props.onHide}
        onShow={props.onShow}
        loading={!promotion}
        headerIcon={<GiftIco/>}
        bodyContent={
            <>
                {
                    !promotion ? <></> : (
                        error ? <div className={"alert alert-danger"}>{error}</div> : (
                                <div>
                                    <ul className="list-unstyled">
                                        <dl>
                                            {types && (
                                                <div className="mb-2">
                                                    <dt>
                                                        {t("modules.promotion.field.order_type.title")}
                                                    </dt>
                                                    <dd>
                                                        <ul>
                                                            {
                                                                types.map((type: string) => (
                                                                    <li key={type}>{type}</li>
                                                                ))
                                                            }
                                                        </ul>
                                                    </dd>
                                                </div>
                                            )}
                                            {promotion.min_basket_money && (
                                                <div className="mb-2">
                                                    <dt>{t("common.word.min_order_price")}</dt>
                                                    <dd>
                                                        <ul>
                                                            <li>
                                                                <Money value={promotion.min_basket_money}/>
                                                            </li>
                                                        </ul>
                                                    </dd>
                                                </div>
                                            )}

                                            {promotion.min_condition_quantity && (
                                                <div className="mb-2">
                                                    <dt>
                                                        {t("modules.promotion.field.min_positions_amount.title")}
                                                    </dt>
                                                    <dd>
                                                        <ul>
                                                            <li>
                                                                {promotion.min_condition_quantity}
                                                            </li>
                                                        </ul>
                                                    </dd>
                                                </div>
                                            )}
                                            {(promotion.conditions && promotion.conditions.length > 0) && (
                                                <div>
                                                    <dt>
                                                        {t("modules.promotion.field.required_positions.title")}
                                                    </dt>
                                                    <dd>
                                                        <ul>
                                                            {getConditions(promotion.conditions).map((condition: any, index: any) => {
                                                                return (
                                                                    <li key={index}>
                                                                        {condition}
                                                                    </li>
                                                                )
                                                            })}
                                                        </ul>
                                                    </dd>
                                                </div>
                                            )}
                                        </dl>
                                    </ul>
                                </div>
                        )
                    )
                }
            </>
        }
    />
}

const mapStateToProps = (state: RootState) => ({
    items: getItems(state.menu),
    categories: getCategories(state.menu),
})

const connector = connect(mapStateToProps);
export default withTranslation()(connector(PromotionInfoModalComponent));
